import {Map} from 'immutable';

import * as Balance from 'actions/balance/balanceAction';
import {GET_BALANCE} from 'sagas/actions';
import * as Signin from 'actions/auth/SigninAction';
import * as LoadAuth from 'actions/auth/loadAuthAction';
import { combobetUrl } from 'constants/Combobet';

const initialState = Map({isLoading: null, value: null});

export default function balance(state = initialState, action = {}) {
    switch (action.type) {
        case Balance.FETCH_BALANCE:
        case GET_BALANCE.REQUEST:
            state = state.set('isLoading', true);
            break;
        case Balance.SUCCESS_FETCH_BALANCE:
            sendBalance(action.data.response.Result);
            state = state.set('isLoading', false);
            state = state.set('value', action.data.response.Result);
            break;
        case GET_BALANCE.SUCCESS:
            state = state.set('isLoading', false);
            state = state.set('value', action.data.Result);
            break;
        case Balance.FAILURE_FETCH_BALANCE:
        case GET_BALANCE.FAILURE:
            state = state.set('isLoading', false);
            state = state.set('value', null);
            break;
        case Signin.SUCCESS_SIGNIN:
        case LoadAuth.SUCCESS_RESTORE:
            if (action.data.Balance) {
                state = state.set('value', action.data.Balance.Result);
            }
            break;

    }

    return state;
}

function sendBalance(balance) {
    if (document.getElementById('combobetFrame')) {
        const win = document.getElementById('combobetFrame').contentWindow;

        const data = {
            balance: balance
        };

        win.postMessage(data, combobetUrl);
    }
}


// WEBPACK FOOTER //
// ./js/shared/reducers/balance.js